import { isValidElement, ReactNode } from 'react';
import { DropDownFilterBy } from '../components/DropDown/types/enums';
import { replaceCSToCDN, getContentStackURL } from '../components/NextgenImage/NextgenImage';

/**
 * @description scrollToElementId makes page scroll on Y-axis to provided `id` of element.
 * @param sId element id to be scroll at viewport.
 * @param offset maintain offset from top of the page.
 */
function scrollToElementId(sId: string, offset?: number) {
  const scrollElement = document.querySelector(`#${sId}`);
  if (scrollElement) {
    const targetElementOffsetTop = (scrollElement as HTMLElement).offsetTop;
    const scrollTop = targetElementOffsetTop - (offset ?? 0); // Adjust the offset as needed
    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  }
}

function getContainerPortalId(portalContainerId: string) {
  return typeof window !== 'undefined' ? document.getElementById(portalContainerId) : null;
}

function filterSearchIgnoreCase(mainText: string, searchText: string, filterBy?: string) {
  return filterBy === DropDownFilterBy.STARTS_WITH
    ? mainText?.toLowerCase().startsWith(searchText?.toString().toLowerCase() || '')
    : mainText?.toLowerCase().includes(searchText?.toString().toLowerCase() || '');
}

export function isElementEmpty(element: ReactNode): boolean {
  if (element === null || element === undefined || typeof element === 'boolean') {
    return true;
  }

  if (typeof element === 'string' || typeof element === 'number') {
    return element.toString().trim() === '';
  }

  if (Array.isArray(element)) {
    return element.every(isElementEmpty);
  }

  if (isValidElement(element)) {
    const { children } = element.props;
    return isElementEmpty(children);
  }

  return false;
}

function getNextgenImageUrl(url: string, width: number, quality: number, format: string) {
  const configs = ConfigService.getConfigs();

  const csImageUrl = configs.NEXT_PUBLIC_CONTENT_STACK_IMAGES_URL as string;

  const updatedSRC = replaceCSToCDN(url, true, csImageUrl, '', '', false);
  return getContentStackURL(updatedSRC, true, '', csImageUrl, width, format, quality, 100, true, '', false);
}

function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function getCdnAssetUrl(url: string) {
  const configs = ConfigService.getConfigs();
  const CDNPostFix = configs.NEXT_PUBLIC_CONTENT_STACK_CDN_POSTFIX as string;
  const CDN_URL = `${configs.DEFAULT_HOST_URL}${CDNPostFix}`;
  const assetUrl = new URL(url);
  return url.replace(assetUrl.origin, CDN_URL);
}

export {
  scrollToElementId,
  getContainerPortalId,
  filterSearchIgnoreCase,
  getNextgenImageUrl,
  isMobileDevice,
  getCdnAssetUrl,
};
